module.exports = __webpack_public_path__ + "img/up9.ee451194.png";